export const LOGIN_PROVIDER_STORAGE_KEY = 'neylia.login-provider.v1';
export const PENDING_LOGIN_PROVIDER_STORAGE_KEY = 'neylia.pending-login-provider.v1';

export type LoginProvider = 'boond' | 'neylia_erp';

export const isLoginProvider = (value: unknown): value is LoginProvider =>
    value === 'boond' || value === 'neylia_erp';
